import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
    OnDestroy,
} from "@angular/core";
import { Subscription, forkJoin } from "rxjs";
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
    cardGroupsNews: any[][] = [];
    isBig: boolean;
    isSmall: boolean;
    randomBackgroundColor: string = "#000000";
    hoverShadowColor: string = "#00000033";
    slides = [];
    showFullContent = false;
    showFullOverview = false;
    showFullWhy = false;
    showFullIns = false;
    showFullBuilding = false;
    showFullCulture = false;
    Notices = [];
    subscription: Subscription;
    HomeContent: any;
    News_event_data: any;
    why_study_data: any;
    mission_data: any;
    vission_data: any;
    MainData: any;
    numVisibleCards: number;
    items: string[] = ["photos", "videos"];
    selectedItem: string = "photos";
    VideoAlbums: any;
    VideoAlbumShown = [];
    imageLoaded = false;
    ImageAlbums: any;
    ImageAlbumShown = [];
    GBMessages: any;
    GBMessageShown = [];
    foundnews: any;
    foundAchivements: any;
    why_study: any;
    // randomBackgroundColor: string = "#000000";
    // hoverShadowColor: string = "#00000033";
    all_achievement_data: any;
    ContentData: any;
    loadingData = true;
    mission_vission_data: any;
    holly_cross_data: any;
    institute_discipline_data: any;
    Building_Compunds_data: any;
    library_data: any;
    culture_data: any;
    overview_data: any;
    computer_lab_data: any;
    Physics_lab_data: any;
    Biology_lab_data: any;
    Chemistry_lab_data: any;
    Multimedia_classroom_data: any;
    constructor(
        private elementRef: ElementRef,
        private emitterService: EmitterService,
        private appService: AppService
    ) {
        this.subscription = this.emitterService.currentMessage.subscribe(
            (message) => {
                if (message === true) {
                    let mainData = localStorage.getItem("mainData");

                    // if (mainData != null) {
                    //     this.ContentData = JSON.parse(mainData);
                    //     this.initializeNewsEventData();
                    // }
                }
            }
        );
    }

    ngOnInit() {
        this.randomBackgroundColor = this.getRandomColor();
        this.fetchHomePageData();
        this.FetchData();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private initializeNewsEventData(): void {
        if (this.ContentData != null) {
            // const news_data = this.ContentData.filter(
            //     (x) => x.ContentCategoryName === "News And Events"
            // );
            // this.foundnews = news_data.slice(0, 3);
            // console.log(news_data, "All news event data");
            this.groupnewsCards();
        }
    }

    private groupnewsCards(): void {
        this.cardGroupsNews = [];
        for (let i = 0; i < this.foundnews.length; i += 3) {
            this.cardGroupsNews.push(this.foundnews.slice(i, i + 3));
        }
    }

    FetchData() {
        forkJoin([
            this.appService.getNotices(),
            this.appService.getContents(),
            this.appService.getVideoAlbums(),
            this.appService.getImageFolders(),
            this.appService.getGBMessages(),
            this.appService.getSlides(),
        ]).subscribe((response: any) => {
            console.log(response, "response FetchData");
            this.Notices = response[0].data.filter(
                (x) => x.ShowScroll === true
            );

            this.Notices.sort((a, b) => b.Id - a.Id);

            this.initializeNewsEventData();

            this.ContentData = response[1].data;

            // To get Welcome Message
            if (this.ContentData != null) {
                let homeContent = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Welcome"
                );
                this.HomeContent = homeContent;
                console.log(this.HomeContent, "Home Contebt");
            }

            if (this.ContentData != null) {
                let news = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "News And Events"
                );
                this.News_event_data = news;
                this.foundnews = this.News_event_data;
                console.log(this.foundnews, "All News Event Data");
            }
            // To get Achievement Data
            if (this.ContentData != null) {
                let achievements_data = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Achievements"
                );
                this.all_achievement_data = achievements_data;
                this.foundAchivements = this.all_achievement_data.slice(0, 3);
                console.log(this.foundAchivements, "All Achievemet Data");
            }
            // To get Mission Data
            if (this.ContentData != null) {
                let news = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Mission"
                );
                this.mission_data = news;
                console.log(this.mission_data, "Misssion Data fsfdf");
            }
            // To get Overview Data
            if (this.ContentData != null) {
                let overview = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Overview"
                );
                this.overview_data = overview;
                console.log(this.overview_data, "Culture");
            }

            // To get why study Data
            if (this.ContentData != null) {
                let why_study = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Why Study Here"
                );
                this.why_study_data = why_study;
                console.log(this.why_study_data, "Why Study Data");
            }
            // To get mission and vission  Data
            if (this.ContentData != null) {
                let mission_vission = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Vision & Mission"
                );
                this.mission_vission_data = mission_vission;
                console.log(this.mission_vission_data, "mission and vission Data");
            }
            // To get Holly Cross Brothers  Data
            if (this.ContentData != null) {
                let holly_cross = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Holly Cross Brothers"
                );
                this.holly_cross_data = holly_cross;
                console.log(this.holly_cross_data, "Holly Cross Brothers");
            }
            // To get Institute Discipline Data
            if (this.ContentData != null) {
                let institute_discipline = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Institute Discipline"
                );
                this.institute_discipline_data = institute_discipline;
                console.log(this.institute_discipline_data, "Institute Discipline");
            }
            // To get Building & Compunds Data
            if (this.ContentData != null) {
                let Building_Compunds = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Building and Compounds"
                );
                this.Building_Compunds_data = Building_Compunds;
                console.log(this.Building_Compunds_data, "Building & Compunds");
            }
            // To get Culture Data
            if (this.ContentData != null) {
                let culture = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Culture"
                );
                this.culture_data = culture;
                console.log(this.culture_data, "Culture");
            }
            // To get Library Data
            if (this.ContentData != null) {
                let library = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Library"
                );
                this.library_data = library;
                console.log(this.library_data, "Library");
            }

            // To get Computer Lab Data
            if (this.ContentData != null) {
                let computer_lab = this.ContentData.filter(
                    (x) => x.ContentCategoryName == " Computer Lab"
                );
                this.computer_lab_data = computer_lab;
                console.log(this.computer_lab_data, "Compter Lab Data ");
            }

            // To get Physics Lab  Data
            if (this.ContentData != null) {
                let Physics_lab = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Physics Lab"
                );
                this.Physics_lab_data = Physics_lab;
                console.log(this.Physics_lab_data, "Physcics Lab Data");
            }

            // To get Biology Lab  Data
            if (this.ContentData != null) {
                let Biology_lab = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Biology Lab"
                );
                this.Biology_lab_data = Biology_lab;
                console.log(this.Biology_lab_data, "Biology Lab Data");
            }
            // To get Chemistry Lab Data
            if (this.ContentData != null) {
                let Chemistry_lab = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Chemistry Lab"
                );
                this.Chemistry_lab_data = Chemistry_lab;
                console.log(this.Chemistry_lab_data, "Chemistry Lab Data");
            }
            // To get Multimedia Classroom Data
            if (this.ContentData != null) {
                let Multimedia_classroom = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Multimedia Class Room "
                );
                this.Multimedia_classroom_data = Multimedia_classroom;
                console.log(this.Multimedia_classroom_data, "Multimedia Classroom Data");
            }
            // To get Vission Data
            if (this.ContentData != null) {
                let news = this.ContentData.filter(
                    (x) => x.ContentCategoryName == "Vision"
                );
                this.vission_data = news;
                // console.log(this.Vission_data, "Vission Data");
            }
            // New Video Item
            this.groupnewsCards();

            this.VideoAlbums = response[2].data;

            let homeVideoFolder = this.VideoAlbums?.find(a => (a.name || a.Name) === "Home Page Video");
            if (homeVideoFolder) {
                this.appService.getVideoAlbumsById(homeVideoFolder.id || homeVideoFolder.Id).subscribe((res: any) => {
                    const videos = res.data?.filter(item => item.IsAlbumFolder === false) || [];
                    for (let i = 0; i < Math.min(3, videos.length); i++) {
                        const video = videos[i];
                        const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                        const match = video.VideoId?.match(regExp);
                        if (match && match[2].length === 11) {
                            video.thumbnailLink = `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg`;
                            video.embedUrl = `https://www.youtube.com/embed/${match[2]}`;
                        } else {
                            video.embedUrl = video.VideoId;
                        }
                        video.name = video.Name || `Video ${i + 1}`;
                        video.id = homeVideoFolder.id || homeVideoFolder.Id; // link to the folder
                        this.VideoAlbumShown.push(video);
                    }
                });
            } else if (this.VideoAlbums != null) {
                for (let i = 0; i < Math.min(3, this.VideoAlbums.length); i++) {
                    this.VideoAlbumShown.push(this.VideoAlbums[i]);
                }
                this.fetchVideoThumbnails(this.VideoAlbumShown);
            }

            this.ImageAlbums = response[3].data;
            // console.log(this.ImageAlbums, "Noman BHai Image");

            if (this.ImageAlbums != null) {
                for (let i = 0; i < Math.min(3, this.ImageAlbums.length); i++) {
                    this.ImageAlbumShown.push(this.ImageAlbums[i]);
                }
            }

            this.GBMessages = response[4].data || [];

            const chiefPatron = this.GBMessages.find(item => 
                item.GBDesignationId == 1 || 
                (item.GBDesignationName && item.GBDesignationName.toLowerCase().includes('chief patron')) ||
                (item.GBDesignation && item.GBDesignation.toLowerCase().includes('chief patron')) ||
                (item.TitleEn && item.TitleEn.toLowerCase().includes('chief patron'))
            );

            const chairman = this.GBMessages.find(item => 
                item.GBDesignationId == 4 || 
                (item.GBDesignationName && item.GBDesignationName.toLowerCase().includes('chairman')) ||
                (item.GBDesignation && item.GBDesignation.toLowerCase().includes('chairman')) ||
                (item.TitleEn && item.TitleEn.toLowerCase().includes('chairman'))
            );

            const principal = this.GBMessages.find(item => 
                item.GBDesignationId == 6 || 
                (item.GBDesignationName && item.GBDesignationName.toLowerCase() === 'principal') ||
                (item.GBDesignation && item.GBDesignation.toLowerCase() === 'principal') ||
                (item.TitleEn && item.TitleEn.toLowerCase().includes('principal') && !item.TitleEn.toLowerCase().includes('vice'))
            );

            const list: any[] = [];
            if (chiefPatron) list.push(chiefPatron);
            if (chairman) list.push(chairman);
            if (principal) list.push(principal);

            if (list.length < 3) {
                const remaining = this.GBMessages.filter(item => 
                    !list.some(x => x.Id === item.Id) && 
                    (item.Placement?.includes("1") || true)
                );
                list.push(...remaining.slice(0, 3 - list.length));
            }

            this.GBMessageShown = list;
            console.log(this.GBMessageShown, "GBMessageShown");

            this.slides = response[5].data;
            console.log(this.slides, "Hello Slider");

            this.loadingData = false;

            setTimeout(() => {
                this.initSlider();
            }, 150);

            setTimeout(() => {
                const canvas = document.getElementById('dew-canvas') as HTMLCanvasElement;
                if (canvas) {
                    const ctx = canvas.getContext('2d');
                    let w: number, h: number;
                    let dews: any[] = [];

                    function resize() {
                        w = canvas.width = canvas.parentElement.offsetWidth;
                        h = canvas.height = canvas.parentElement.offsetHeight;
                    }
                    window.addEventListener('resize', resize);

                    class Dew {
                        x: number;
                        y: number;
                        r: number;
                        v: number;
                        a: number;
                        constructor() {
                            this.x = Math.random() * w;
                            this.y = h + Math.random() * 200;
                            this.r = Math.random() * 2.5 + 0.5;
                            this.v = Math.random() * 0.8 + 0.2;
                            this.a = Math.random() * 0.5 + 0.1;
                        }
                        update() {
                            this.y -= this.v;
                            if (this.y < -10) {
                                this.y = h + 10;
                                this.x = Math.random() * w;
                            }
                        }
                        draw() {
                            ctx.beginPath();
                            ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
                            ctx.fillStyle = `rgba(255, 255, 255, ${this.a})`;
                            ctx.fill();
                        }
                    }

                    function init() {
                        resize();
                        for (let i = 0; i < 40; i++) {
                            dews.push(new Dew());
                        }
                        animate();
                    }

                    function animate() {
                        ctx.clearRect(0, 0, w, h);
                        dews.forEach(d => { d.update(); d.draw(); });
                        requestAnimationFrame(animate);
                    }

                    init();
                }
            }, 100);
        });
    }
    // library_data(library_data: any, arg1: string) {
    //     throw new Error("Method not implemented.");
    // }

    filteredNoticesCategory(category: string): any[] {
        return this.Notices.filter(
            (item) => item.NoticeCategoryName === category
        );
    }

    truncateText(text: string, maxLength: number) {
        // Remove HTML tags from the text
        const plainText = text.replace(/<[^>]*>/g, "");

        // Check if the plain text length is greater than the maximum length
        if (plainText.length > maxLength) {
            // Truncate the plain text to the maximum length and append "..." at the end
            return plainText.substring(0, maxLength) + "...";
        } else {
            // If the plain text length is within the maximum length, return the original text
            return text;
        }
    }

    toggleShowContent() {
        this.showFullContent = !this.showFullContent;
    }

    toggleShowOverview() {
        this.showFullOverview = !this.showFullOverview;
    }
    toggleShowWhy() {
        this.showFullOverview = false;
    }

    toggleShowIns() {
        this.showFullIns = !this.showFullIns;
    }

    toggleShowBuilding() {
        this.showFullBuilding = !this.showFullBuilding;
    }
    toggleShowCulture() {
        this.showFullCulture = !this.showFullCulture;
    }

    fetchHomePageData() {
        fetch("assets/json/homePage.json")
            .then((response) => response.json())
            .then((data) => {
                this.slides = data.slideImageTop;
            })
            .catch((error) => console.error("Error fetching data:", error));
    }

    @HostListener("window:resize")
    onResize() {
        this.smallScreen();
    }

    getRandomColor(): string {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    onCardHover() {
        this.hoverShadowColor = this.randomBackgroundColor;
    }

    onCardLeave() {
        this.hoverShadowColor = "#00000033";
    }

    smallScreen() {
        this.isSmall = window.innerWidth < 1300;
        this.isBig = window.innerWidth > 1300;
    }

    changeBackgroundImage(imageUrl: string) {
        const element =
            this.elementRef.nativeElement.querySelector(".bgImageTab");
        element.style.setProperty("--tab-background-image", `url(${imageUrl})`);
    }

    onNavigate(url: string, gb?: any) {
        let MyUrl = "";
        if (url.startsWith("http://") || url.startsWith("https://")) {
            MyUrl = url;
        } else {
            MyUrl = "https://" + url;
        }
        window.open(MyUrl, "_blank");
    }

    formatGbTitle(gb: any): string {
        if (!gb) return 'Message';
        const desig = (gb.GBDesignation || gb.GBDesignationName || gb.gbDesignationName || '').toLowerCase();
        const desigId = gb.GBDesignationId || gb.gbDesignationId;
        if (desigId == 1 || desig.includes('chief patron')) return 'Message of Chief Patron';
        if (desigId == 4 || desig.includes('chairman')) return 'Message of Chairman';
        if (desigId == 6 || (desig.includes('principal') && !desig.includes('vice'))) return 'Message of Principal';
        
        let title = gb.TitleEn || gb.GBDesignationName || gb.GBDesignation || 'Message';
        if (!title.toLowerCase().startsWith('message of')) {
            return `Message of ${title}`;
        }
        return title;
    }

    getGbRoute(gb: any): string {
        const desigId = gb.GBDesignationId || gb.gbDesignationId;
        const desigName = (gb.GBDesignation || gb.GBDesignationName || gb.gbDesignationName || '').toLowerCase();
        
        if (desigId == 1 || desigName.includes('chief patron')) return 'message-of-chief-patron';
        if (desigId == 4 || desigName.includes('chairman')) return 'message-of-chairman';
        if (desigId == 6 || desigName.includes('principal')) return 'message-of-principal';
        if (desigId == 12 || (desigName.includes('college') && desigName.includes('vice principal'))) return 'message-of-vice-principal-college';
        if (desigName.includes('english version') && desigName.includes('vice principal')) return 'message-of-vice-principals-english-version';
        if (desigName.includes('bangla version') && desigName.includes('vice principal')) return 'message-of-vice-principal-bangla-version';
        return gb.Id ? gb.Id.toString() : '';
    }

    NoAdmissionAlert() {
        alert("Admission services not open yet.");
        return;
    }

    TransformUrl(value) {
        if (!value) return '/assets/img/default_logo.png';
        if (value.includes("https://") || value.includes("http://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }

    fetchVideoThumbnails(albums: any[]) {
        albums.forEach(album => {
            if (!album.thumbnailLink) {
                const folderId = album.id || album.Id;
                if (folderId) {
                    this.appService.getVideoAlbumsById(folderId).subscribe((res: any) => {
                        const videos = res.data?.filter(item => item.IsAlbumFolder === false);
                        if (videos && videos.length > 0) {
                            const firstVideoUrl = videos[0].VideoId;
                            const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                            const match = firstVideoUrl?.match(regExp);
                            if (match && match[2].length === 11) {
                                album.thumbnailLink = `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg`;
                            }
                        }
                    });
                }
            }
        });
    }

    get displayNotices(): any[] {
        if (!this.Notices || this.Notices.length === 0) return [];
        if (this.Notices.length === 1) {
            return [
                this.Notices[0],
                this.Notices[0],
                this.Notices[0],
                this.Notices[0],
                this.Notices[0],
                this.Notices[0]
            ];
        }
        if (this.Notices.length === 2) {
            return [
                ...this.Notices,
                ...this.Notices,
                ...this.Notices,
                ...this.Notices
            ];
        }
        return [...this.Notices, ...this.Notices];
    }

    get scrollAnimationDuration(): string {
        const count = this.displayNotices.length;
        if (count === 0) return '0s';
        const halfCount = count / 2;
        const duration = Math.max(12, halfCount * 4);
        return `${duration}s`;
    }

    initSlider() {
        const carouselEl = document.getElementById('carouselExampleCaptions');
        if (carouselEl) {
            try {
                if ((window as any).bootstrap && (window as any).bootstrap.Carousel) {
                    const bsCarousel = (window as any).bootstrap.Carousel.getOrCreateInstance(carouselEl, {
                        interval: 3500,
                        ride: 'carousel',
                        wrap: true,
                        pause: 'hover'
                    });
                    bsCarousel.cycle();
                } else if ((window as any).$ && (window as any).$('#carouselExampleCaptions').carousel) {
                    (window as any).$('#carouselExampleCaptions').carousel({
                        interval: 3500,
                        ride: 'carousel',
                        wrap: true,
                        pause: 'hover'
                    });
                    (window as any).$('#carouselExampleCaptions').carousel('cycle');
                }
            } catch (e) {
                console.error('Error auto-starting carousel', e);
            }
        }
    }
}
